$shm_hitalama_skills_source $shm_textarea_code
	entry $shm_hitalama_skills_entry
	path \SKILL.md
	sidebar_showed true
	saving? false
	failure? \
